module.exports = __webpack_public_path__ + "img/chest_active.b2281e87.png";